var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCollectedProgressComplete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E34B31"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4132 16.0002H21.5243C22.1354 16.0002 22.6354 15.5002 22.6354 14.8891V8.22244C22.6354 7.61133 22.1354 7.11133 21.5243 7.11133H18.2222V11.5558L16 10.4447L13.7465 11.5558V7.11133H10.4132C9.83332 7.11133 9.33228 7.61133 9.33228 8.22244V14.8891C9.33228 15.5002 9.83332 16.0002 10.4132 16.0002Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.191 7.11133V11.5558L15.9375 10.4447L13.7465 11.5558V7.11133H18.191ZM23.7872 18.4943C24.4049 18.0363 25.2736 18.17 25.7292 18.7884C26.184 19.4065 26.0521 20.2745 25.375 20.7294L20.684 24.1849C20.0667 24.6395 19.3066 24.8891 18.5417 24.8891H6.52431C6.25177 24.8891 6 24.6391 6 24.3336L6 20.9697C6 20.666 6.22056 20.4134 6.52431 20.4134L8.44722 20.5072L10.0618 19.1968C10.791 18.6065 11.7292 18.2853 12.6354 18.2853H18.2212C18.8983 18.2853 19.4319 18.9197 19.3191 19.5829C19.2281 20.1294 18.6847 20.5072 18.1604 20.5072H15.4434C15.1708 20.5072 14.9191 20.7589 14.9191 21.0315C14.9191 21.3041 15.1397 21.5558 15.4434 21.5558H19.6309L23.7872 18.4943Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectedProgressComplete);
export default __webpack_public_path__ + "static/media/collected-progress-complete.4d395a117b91f4ed45384a8ccf30db98.svg";
export { ForwardRef as ReactComponent };